import { subselect } from './root';
import { propertiesSelector } from './properties';
import { PLAYER_CONTENT_KIND } from '../../../player/constants';

const currentlyPlayingSelector = (podTrackerState, currentlyPlayingKind) => {
  const { currentPlayingAd } = propertiesSelector(podTrackerState);
  const isVod = currentlyPlayingKind === PLAYER_CONTENT_KIND.VOD;
  const contentType = isVod ? 'vod' : 'content';
  return currentPlayingAd ? 'ad' : contentType;
};

export const podTrackerCurrentlyPlayingSelector = subselect(currentlyPlayingSelector);
